<div
    class="tw-pl-2 tw-flex tw-flex-col tw-justify-center"
    #tooltipTrigger
    (mouseleave)="closeCustomTooltip()">
    <mat-icon
        color="primary"
        fontSet="material-symbols-outlined"
        (mouseenter)="showCustomAsnTooltip()"
        (click)="$event.stopPropagation()">
        help
    </mat-icon>
</div>
